import { Answer } from './Answer'
import { BookingSlot } from './BookingSlot'

export class BookingRequest {

    constructor(
        public id: string,
        public bookingSlot: BookingSlot,
        public areaId: string,
        public firstName: string,
        public lastName: string | null,
        public emailAddress: string,
        public phoneNumber: string | null,
        public partySize: number,
        public notes: string | null,
        public agreedToMarketing: boolean,
        public agreedToTerms: boolean,
        public reasonId: string | null,
        public eventId: string | null,
        public basketItems: {
            productId: string
            skuId: string
            quantity: number
            modifierSkuIds?: string[]
            menuItemId?: string
        }[] | null,
        public answers: Answer[],
        public depositPaymentIntentId: string | null,
        public requiresWheelchairAccess: boolean,
        public requiresDogFriendly: boolean,
        public requiresPramAccessible: boolean,
        public requiresHighchairFriendly: boolean,
        public utmSource: string | null,
        public utmMedium: string | null,
        public utmCampaign: string | null,
        public durationMinutes: number | null = null,
        public additionalBookings: AdditionalBookingRequest[] = [],
        public agreedToMerchantPrivacy: boolean | null = null
    ) { }
}

export interface AdditionalBookingRequest {
    id: string
    bookingSlot: BookingSlot
    areaId: string
    reasonId: string
    durationMinutes: number
    basketItems: NonNullable<BookingRequest['basketItems']>
    answers: Answer[]
}
